import axios from "axios";
import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { IMandadoNominalstore } from "..";
import { IConsultaMandado } from "../../../interface/fichaMandado";

export interface IMandadoNominalModuleStore {
  resultadoMandadoNominal: IConsultaMandado[] | null;
  mensagemMandado?: string;
  consultaMandadoNominal(
    url: string,
    nome: undefined | string,
    vulgo: undefined | string,
    nomeMae: undefined | string,
    nomePai: undefined | string,
    e?: FormEvent
  ): Promise<void>;
  limparConsultaMandadoNominal(): void;
}

export default (set: SetState<IMandadoNominalstore>) =>
  ({
    resultadoMandadoNominal: null,
    async consultaMandadoNominal(url, nome, vulgo, nomeMae, nomePai, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        const response = await axios.get(`${url}/mandado`, {
          params: {
            nome1: nome,
            vulgo1: vulgo,
            nomemae: nomeMae,
            nomepai: nomePai,
          },
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        if (response.status === 200) {
          set((state) => ({
            ...state,
            global: {
              ...state.global,
              loading: false,
            },
            mandado: {
              ...state.mandado,
              resultadoMandadoNominal: response.data.pessoa,
            },
          }));
        }
        if (response.status === 400) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 401) {
          toast.error(
            "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          // logout()
        }
        if (response.status === 404) {
          // toast.error(`${response.data.message}`, {
          //   position: toast.POSITION.TOP_CENTER,
          //   autoClose: 4000,
          // })
          set((state) => ({
            mandado: {
              ...state.mandado,
              resultadoMandadoNominal: null,
              mensagemMandado: response.data.message,
            },
          }));
        }
        if (response.status === 500 || response.status === 503) {
          toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
          return;
        }
        if (response.status === 504) {
          toast.error(
            "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          return;
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaMandadoNominal() {
      set((state) => ({
        ...state,
        mandado: {
          ...state.mandado,
          resultadoMandadoNominal: null,
          mensagemMandado: undefined,
        },
      }));
    },
  } as IMandadoNominalModuleStore);
